import pubsub from "@viewlift/pubsub";
import jwtDecode from "jwt-decode";
import localforage from "localforage";
import { updateSseStore } from "./helpers";
import { createStore } from "./helpers/manageSSE";
import { getToken } from "./MFEs/web-authentication-sdk/src/helper";

let authorization_token,userId,connectionState = 'IDLE';

export const connectSSE = async (token) => {

    authorization_token = token
    userId = jwtDecode(authorization_token).userId
    //add site name dynamic
    let site = (window?.app_data?.site?.siteInternalName) || null
    const res = await fetch(window?.sseBaseUrl+`/sse/v2/reader/non-persistent/viewlift/${site}/${userId}?device=WEB`, {
      headers:{
          Authorization: authorization_token,
        } 
      })

     if(res.ok){
      pubsub.publish('SSEconnected');
     }

      const reader = res.body.getReader();
      let startTime, endTime, timeDiff ;
      function start() {
        startTime = new Date();
      };
      function end() {
        endTime = new Date();
        timeDiff = endTime - startTime; //in ms
        // strip the ms
        timeDiff /= 1000;
      
        // get seconds 
         timeDiff = Math.round(timeDiff); // in seconds
      }

      const processEvent = () => {
        reader.read().then(({ value, done }) => {

          if (done) {
            console.log("connection closed / done ")
            connectionState = "IDLE" 
            return;
          }
          if(connectionState == 'IDLE') connectionState = "ACTIVE"
  
          // let res = new TextDecoder("utf-8").decode(value)
  
          // console.log(JSON.parse(res),connectionState);
          // let dataSSE = JSON.parse(res)
  
          try{
            let live_data = new TextDecoder("utf-8").decode(value)
            let parsed_live_data =  typeof live_data != "Object" ?  JSON.parse(live_data) : live_data
            end()
            if (timeDiff > 10) {connectSSE(token) }
            if (parsed_live_data?.payload) {
                let decode_payload_data = JSON.parse(window.atob(parsed_live_data?.payload))
                let notification_type = decode_payload_data.notificationType
                let payload_data_parsed = decode_payload_data && typeof decode_payload_data?.payload != "Object"?  JSON.parse(decode_payload_data?.payload) : decode_payload_data?.payload
                if(notification_type =='GAME_LIVE_SCORE' && decode_payload_data){
                //  return payload_data_parsed
                console.log("GAME_LIVE_SCORE",decode_payload_data?.contentMeta?.id,payload_data_parsed)
                  updateSseStore({[decode_payload_data.contentMeta.id]:payload_data_parsed})
                }else if(notification_type =='GAME_STATE_CHANGE'){
                  console.log("GAME_STATE_CHANGE",decode_payload_data?.contentMeta?.id,payload_data_parsed)
                  updateSseStore({[decode_payload_data.contentMeta.id]:payload_data_parsed})
                }else if(notification_type =='GAME_HIGHLIGHTS_UPDATED'){
                  console.log('GAME_HIGHLIGHTS_UPDATED')
                  updateSseStore({[decode_payload_data.contentMeta.id]:payload_data_parsed})
                }else if(notification_type =='USER_DEVICE_ADDED'){
                    console.log('USER_DEVICE_ADDED')
                }else if(notification_type =='USER_DEVICE_REMOVED'){
                  pubsub.publish("DEVICE_REMOVED",payload_data_parsed)
                }else if(notification_type =='USER_DEVICE_LIMIT_REACHED'){
                    console.log("USER_DEVICEUSER_DEVICE_LIMIT_REACHED_ADDED")
                }else if(notification_type =='USER_STREAM_LIMIT_REACHED'){
                    console.log("USER_STREAM_LIMIT_REACHED")
                }else if(notification_type =='DEBUG_ENTITLEMENT'){
                    console.log("DEBUG_ENTITLEMENT")
                }else if(notification_type =='DEBUG_DEVICE'){
                    console.log("DEBUG_DEVICE")
                }else{
                    console.log("no notification found to be handled")
                }
          }
          }catch(err){
            console.log(err)
            end()
          }
        start()
        processEvent();
        })
        .catch((err) => {
          getToken((token) => {
            connectSSE(token)
          })
          console.log("error in sse connection.....reconnecting ")
        })
      };
      start()
      processEvent();
      // setInterval(() => {
      //   processEvent();
      // },1000)
}

export const checkSSE = () => {
  return connectionState 
}

export const sseWatchDog = (item) => {

  const stateMap = ['default','pre','live','post','end']

  if(!window.sseWatchDogObj){
    window.sseWatchDogObj= {}
  }

  if(window.sseWatchDogObj[item.id]) return // if timer exists return 

  let currentState = item.currentState

  if(currentState != "end"){
    let nextIndex = stateMap.indexOf(currentState) + 1 
    let nextStateTime = item.states[stateMap[nextIndex]].startDateTime * 1000

    if(nextStateTime){    
        let currentTime =  Date.now();

        let timeDiff = nextStateTime - currentTime + 60000 // + 60000 to wait for 1 min before calling  

        window.sseWatchDogObj[item.id] = setTimeout(async () => {
          let sseStore = await localforage.getItem('SseStore')
          let checkGameState = sseStore[item.id]?.currentState == stateMap[nextIndex] ?  true : false
          clearTimeout(window.sseWatchDogObj[item.id]);
          if(checkGameState){
            return
          }  
          getGameData({gameId:item.id})
        },timeDiff)
      }
  }

}

export const getGameData = (gameIDs) => {

  if(gameIDs.length > 0){

    let gameId = gameIDs.join(',')

    getToken()
    .then((token) => {

      let site = window?.app_data?.site.siteInternalName

      const options = {
        method: 'GET',
        headers: {
          accept: 'application/json',
          Authorization: token 
        }
      };

      fetch(`${window.apiBaseUrl}/v3/content/game?ids=${gameId}&site=${site}`,options)
      .then(response => response.json())
      .then(async (response) => {
        if(response?.records?.length > 0 ){
          createStore(response.records)
        }
      })
      .catch(err => {
        console.error(err)
      });
    })

  }
}

export const syncSSEStore = () => {
  let store = JSON.parse(localStorage.getItem('SseStore'))
    for (const id in store) {
      window[id] = store[id];
    }
    
}